// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lx-1";
export var messageSideRight = "_lx-2";
export var subscribeToBackInStockBubbleContainer = "_lx-0";